import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@app/core/services/user/user.service';
import { Entity } from '@app/shared/models/models.interface';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface AuditInfoOption {
  label: string;
  value?: any;
  isDate?: boolean;
  isTime?: boolean;
}
@Component({
  selector: 'vfs-audit-info',
  templateUrl: './audit-info.component.html',
  styleUrls: ['./audit-info.component.scss']
})
export class AuditInfoComponent implements OnInit {
  @Input() entity: Entity;
  @Input() options: AuditInfoOption[];
  @Input() useTemplate = false;

  all$: Observable<any>;
  creationUser$: Observable<any>;
  modificationUser$: Observable<any>;

  constructor(protected userService: UserService) {}

  ngOnInit() {
    this.creationUser$ = this.entity.id
      ? this.userService
          .getByUsername(this.entity.creationUser)
          .pipe(catchError(error => of({ username: this.entity.creationUser ? this.entity.creationUser : '' })))
      : of({ username: '' });
    this.modificationUser$ = this.entity.id
      ? this.userService
          .getByUsername(this.entity.lastModificationUser)
          .pipe(
            catchError(error =>
              of({ username: this.entity.lastModificationUser ? this.entity.lastModificationUser : '' })
            )
          )
      : of({ username: '' });
    this.all$ = combineLatest(this.creationUser$, this.modificationUser$).pipe(
      map(result => ({ creationUser: result[0], modificationUser: result[1] }))
    );
  }
}
